import { render, staticRenderFns } from "./ShowEventsForm.vue?vue&type=template&id=74c264b4&scoped=true&"
import script from "./ShowEventsForm.vue?vue&type=script&lang=ts&"
export * from "./ShowEventsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ShowEventsForm.vue?vue&type=style&index=0&id=74c264b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c264b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
